import React from "react";
import { Typography, Box, Divider, List, ListItem } from "@mui/material";
function Overview() {
  return (
    <Box sx={{ p: 4, bgcolor: "background.default" }}>
        <Typography
            variant="h3"
            sx={{
              fontWeight: "bold",
              color: "primary.main",
              mb: 2,
            }}
        >
          Innocence Project
          OpenAI Intake App
        </Typography>
        <Divider sx={{ width: "50%", mb: 3, bgcolor: "primary.main" }} />
        <Typography
          variant="body1"
          sx={{
            fontSize: "1.1rem",
            lineHeight: 1.6,
            color: "text.secondary",
            my: "24px"
          }}
        >
          The OpenAI Intake App processes all intake letters in Filevine. The app will transcribe the letter to text, 
          summarize the contents of the letter, and perform an analysis on if the letter meets the requirements that 
          the Innocence Project has for taking on a case. If additional info is required, there will be an outline of
          what information is missing in the letter.
        </Typography>
      <Typography
        variant="h3"
        sx={{
          fontWeight: "bold",
          color: "primary.main",
          mb: 2,
        }}
      >
        Instructions
      </Typography>
      <Divider sx={{ width: "50%", mb: 3, bgcolor: "primary.main" }} />
      <Typography
        variant="body1"
        sx={{
          fontSize: "1.1rem",
          lineHeight: 1.6,
          color: "text.secondary",
        }}
      >
      <List sx={{ listStyle: "circle", pl: 4 }}>
        <ListItem sx={{ display: "list-item" }}>
          All PDF files in a Correspondence folder with "ltr_rec" in the file name will be automatically processed.
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          Click on Documents to see all the processed files. 
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          Click on a file to see the original pdf, as well as the processed information such as the transcription, summary, and analysis. 
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          For any questions, issues or suggestions, reach out to lilly@contenda.co. 
        </ListItem>
      </List>
      </Typography>
    </Box>
  );
}
export default Overview;